import throwMessage from "../../utils/throwMessage";

function isEmpty(obj) {
  for (const prop in obj) {
    if (Object.hasOwn(obj, prop)) {
      return false;
    }
  }
  return true;
}

const delay = (ms) => new Promise(resolve => setTimeout(resolve, ms));

export const fetchEconomicCalendar = async (params = {}, retryCount = 0) => {
  const isOnline = typeof navigator !== "undefined" ? navigator.onLine : true;
  if (!isOnline) {
    throwMessage("error", "Check Your Network Connection");
    return null;
  }

  const { period = "today", from = "", to = "", currency = "", impact = "" } = params;

  const user = localStorage.getItem("user");
  const TC_TOKEN_AUTH = localStorage.getItem("TC_TOKEN_AUTH");

  const queryParams = new URLSearchParams({
    user_id: JSON.parse(user)?._id || "",
    role: JSON.parse(user)?.role || "",
    period,
    ...(from && { from }),
    ...(to && { to }),
    ...(currency && { currency }),
    ...(impact && { impact }),
  });

  try {
    const response = await fetch(
      `${process.env.REACT_APP_API}/economic-calendar?${queryParams}`,
      {
        method: "GET",
        credentials: "include",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: `Bearer ${TC_TOKEN_AUTH}`,
        },
      }
    );

    if (!response.ok) {
      if (response.status === 429) {
        const maxRetries = 3;
        if (retryCount < maxRetries) {
          const waitTime = Math.min(10000 * Math.pow(2, retryCount), 60000);
          throwMessage("info", `Rate limited. Retrying in ${waitTime / 1000} seconds... (${retryCount + 1}/${maxRetries})`);
          await delay(waitTime);
          return fetchEconomicCalendar(params, retryCount + 1);
        } else {
          throwMessage("error", "Rate limit persists. Please try again later.");
          return null;
        }
      } else {
        throwMessage("error", `Calendar error: HTTP ${response.status}`);
        return null;
      }
    }

    return await response.json();
  } catch (err) {
    if (!isEmpty(err) && err.message?.includes("429")) {
      const maxRetries = 3;
      if (retryCount < maxRetries) {
        const waitTime = Math.min(10000 * Math.pow(2, retryCount), 60000);
        throwMessage("info", `Rate limited. Retrying in ${waitTime / 1000} seconds... (${retryCount + 1}/${maxRetries})`);
        await delay(waitTime);
        return fetchEconomicCalendar(params, retryCount + 1);
      } else {
        throwMessage("error", "Rate limit persists. Please try again later.");
        return null;
      }
    } else if (!isEmpty(err)) {
      throwMessage("error", "Failed to load economic calendar");
    }
    return null;
  }
};
